import {Observable} from 'rxjs/Observable';
import {OptionDialogStaticAccessor} from './option.dialog.accessor';
import {InputDialogConfig, OptionDialog, OptionDialogConfig, OptionDialogResult} from './option.dialog';

class OptionDialogResultImpl implements OptionDialogResult {

    private _apply: (value: any) => void;
    private _cancel: (value: any) => void;

    constructor(observable: Observable<any>) {
        observable.subscribe(
            (value: string) => this._apply && this._apply(value),
            (value: string) => this._cancel && this._cancel(value)
        )
    }

    onConfirmAction(callback: (value: any) => void): OptionDialogResult {
        this._apply = callback;
        return this;
    }

    onCancelAction(callback: (value: any) => void): OptionDialogResult {
        this._cancel = callback;
        return this;
    }
}

class OptionDialogAccessorDelegate implements OptionDialog {

    constructor(private _id: string) {}

    showConfirmDialog(opts: OptionDialogConfig): OptionDialogResult {
        return new OptionDialogResultImpl(OptionDialogStaticAccessor.showConfirmDialog(this._id, opts));
    }

    showInputDialog(opts: OptionDialogConfig, inputOpts?: InputDialogConfig): OptionDialogResult {
        return new OptionDialogResultImpl(OptionDialogStaticAccessor.showInputDialog(this._id, opts, inputOpts));
    }

    showMessageDialog(opts: OptionDialogConfig): OptionDialogResult {
        return new OptionDialogResultImpl(OptionDialogStaticAccessor.showMessageDialog(this._id, opts));
    }
}

export const InjectOptionDialog: (id?: string) => PropertyDecorator = (id?: string) => {
    return (target: Object, property: string | symbol) => {
        target[property] = new OptionDialogAccessorDelegate(id);
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/option-dialog/option.dialog.decorator.ts